import React from "react";

import './ObjectSummaryRow.scss';

const ObjectSummaryRow = ({data}) => {

	if(data === null) {
		return <div />
	}

	return (
		<div className="object-summary-summary">
			{
				data.map((d, i) => (
					<div key={i}>
						<div className="object-summary-summary-title">{d.title}</div>
						<div className="object-summary-summary-value" style={{color: d.blue ? '#40A0C1' : '#000'}}>{d.value || '-'}</div>
					</div>
				))
			}
		</div>
	)
};

export default ObjectSummaryRow;